import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/registerLiteAppApi'
import { message } from 'hljd'
import { isPhone } from '@hlj/hlj-utils'

class Store {
  @observable writeVisible = false

  @observable register_status
  @observable status
  @action
  getStatus = async () => {
    let { data } = await Api.checkBind()
    runInAction(() => {
      if (data) {
        this.register_status = data.register_status
        this.status = data.status
      }
    })
  }

  @action
  buy = async () => {
    const { register_status, status } = this
    if (status == 1) {
      if (register_status == 1) {
        this.writeVisible = true
      } else if (register_status == 0) {
        window.location.href =
          '#/localMerchant/cashier?payType=2&price=300&title=注册小程序&apiName=/p/wedding/Admin/APIMerchantWeappReg/pay&checkApi=/p/wedding/Admin/APIMerchantWeapp&return_url=/localMerchant/liteApp/register?visible=true&&checkParams={"register_status":"1"}'
      } else {
        return message.info('您已购买过该服务！')
      }
    } else {
      window.location.href =
        '#/localMerchant/cashier?payType=2&price=300&title=注册小程序&apiName=/p/wedding/Admin/APIMerchantWeappReg/pay&checkApi=/p/wedding/Admin/APIMerchantWeapp&return_url=/localMerchant/liteApp/register?visible=true&checkParams={"register_status":"1"}'
    }
  }

  @observable contact_phone = ''
  @observable contact_phone_show = false

  @observable contact_email = ''
  @observable contact_email_show = false

  @observable code = ''
  @observable code_show = false

  @observable imgCode = ''
  @observable imgCode_show = false

  @action
  changeValue = type => e => {
    this[type] = e.target.value
    this[type + '_show'] = false
  }

  codeCount = 0
  @observable imgCodeSrc = '/p/wedding/index.php/Web/Login/verify'
  @action
  imgCodeSrcChange = () => {
    let src =
      this.imgCodeSrc.indexOf('?') > 0
        ? this.imgCodeSrc.split('?')[0]
        : this.imgCodeSrc
    this.codeCount++
    this.imgCodeSrc = src + '?v=' + this.codeCount
  }

  @observable count = 60
  @observable is_getCode = false
  @action
  getMsgCode = async () => {
    const { imgCode, contact_phone } = this
    if (!contact_phone) {
      return (this.contact_phone_show = true)
    }

    if (!imgCode) {
      return (this.imgCode_show = true)
    }

    let { success } = await Api.msgCode({
      image_code: imgCode,
      phone: contact_phone
    })
    if (success) {
      this.is_getCode = true
      let interval = setInterval(() => {
        this.count--
        if (this.count < 1) {
          this.is_getCode = false
          this.count = 60
          window.clearInterval(interval)
        }
      }, 1000)
    } else {
      return (this.imgCode_show = true)
    }
  }

  @observable closeTime = 5
  @observable closeInterval
  @observable successVisible = false

  @action
  toSubmit = async () => {
    const { imgCode, code, contact_email, contact_phone } = this

    const regEmail = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/ //邮箱正则

    if (!contact_phone) {
      return (this.contact_phone_show = true)
    }
    if (!isPhone(contact_phone)) {
      return (this.contact_phone_show = true)
    }

    if (!imgCode) {
      return (this.imgCode_show = true)
    }

    if (!code) {
      return (this.code_show = true)
    }

    if (!contact_email) {
      return (this.contact_email_show = true)
    }
    if (!regEmail.test(contact_email)) {
      return (this.contact_email_show = true)
    }

    let { success, msg } = await Api.contact({
      code,
      contact_email,
      contact_phone
    })
    if (success) {
      this.successVisible = true
      this.closeInterval = setInterval(() => {
        this.closeTime--
        if (this.closeTime < 1) {
          this.successVisible = false
          window.clearInterval(this.closeInterval)
          window.location.href = '#/localMerchant/liteApp/authorize'
        }
      }, 1000)

      this.closeModal()
    } else {
      if (msg == '验证码错误') {
        return (this.code_show = true)
      }
    }
  }

  @action
  gotoAuthorize = () => {
    this.successVisible = false
    window.clearInterval(this.closeInterval)
    window.location.href = '#/localMerchant/liteApp/authorize'
  }

  @action
  closeModal = () => {
    this.contact_phone = ''
    this.contact_phone_show = false

    this.contact_email = ''
    this.contact_email_show = false

    this.code = ''
    this.code_show = false

    this.imgCode = ''
    this.imgCode_show = false

    this.writeVisible = false
  }
}

export default new Store()
